import { Flex } from "@chakra-ui/react";
import ChocPagination from "@choc-ui/paginator";
import { byLook } from "theme/look";

type PaginationProps = {
  hidePageSize: boolean;
  total: number;
  current: number;
  pageSize: number;
  goToPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
};

const pageStyles = byLook(
  {
    base: {
      minW: 8,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "gray.100",
      borderRadius: "md",
      backgroundColor: "transparent",
      fontWeight: "medium",
      _dark: { borderColor: "#2C3230" },
    },
    active: {
      backgroundColor: "teal.600",
      borderColor: "teal.600",
      color: "white",
      _dark: {
        backgroundColor: "teal.500",
        borderColor: "teal.500",
        color: "brand.450",
      },
    },
    hover: {
      backgroundColor: "gray.50",
      _dark: { backgroundColor: "whiteAlpha.100" },
    },
  },
  {
    base: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "gray.400",
      borderRadius: 0,
      backgroundColor: "transparent",
    },
    active: undefined,
    hover: { backgroundColor: "gray.400" },
  },
);

const Pagination = ({
  hidePageSize,
  total,
  current,
  pageSize,
  goToPage,
  setPageSize,
}: PaginationProps) => {
  if (total === 0) {
    return null;
  }

  return (
    <Flex
      key="pagination"
      w="full"
      bg="transparent"
      p={2}
      alignItems="center"
      justifyContent="flex-end"
      borderBottomRadius={4}
      overflow="hidden"
    >
      <ChocPagination
        size="sm"
        paginationProps={{ display: "flex" }}
        baseStyles={pageStyles.base}
        activeStyles={pageStyles.active}
        current={current}
        total={total}
        pageSize={pageSize}
        hoverStyles={pageStyles.hover}
        onChange={(currentPage) => {
          typeof currentPage !== "undefined" && goToPage(currentPage - 1);
        }}
        onShowSizeChange={(currentPage, size) => {
          typeof currentPage !== "undefined" && size && setPageSize(size);
        }}
        showSizeChanger={!hidePageSize}
        colorScheme={byLook("teal", "gray")}
        responsive={true}
        pageNeighbours={2}
      />
    </Flex>
  );
};

export { Pagination };
